export default "__VITE_ASSET__522798a8__"